export enum FeedbackType {
    SimpleCompacto = "Lista",
    SimpleExtendido = "Opción única",
    Multiple = "Selección múltiple"
}